export const createFormFunnel = id => `configFormFunnel${id}`;
export const createDeleteFormFunnel = id => `configDeleteFormFunnel${id}`;